import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useUserContext } from '../../contexts/UserContext';

const COMPANY_SETUP_PATH = '/register/company';

/**
 * Free-demo / owner signup creates CompanyOwner first. Until a Company exists,
 * send the owner to the slim company registration step.
 */
export function OwnerCompanySetupGate({ children }: { children: ReactNode }) {
    const location = useLocation();
    const { companyOwner, company, businessAdmin, companyUser, isLoading } = useUserContext();

    if (isLoading || businessAdmin) {
        return children;
    }

    // Employees with a company (or any loaded company) skip the gate.
    if (company || companyUser?.companyId) {
        if (location.pathname === COMPANY_SETUP_PATH) {
            return <Navigate to="/" replace />;
        }
        return children;
    }

    if (companyOwner && location.pathname !== COMPANY_SETUP_PATH) {
        return <Navigate to={COMPANY_SETUP_PATH} replace />;
    }

    return children;
}
